"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileListLayout = MobileListLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const dataview_1 = require("primereact/dataview");
const progressspinner_1 = require("primereact/progressspinner");
const react_i18next_1 = require("react-i18next");
const FiltersComponent_1 = require("../../filter/FiltersComponent");
function MobileListLayout({ items, loading, pagination, fetchData, renderItem, renderSkeleton, globalFilterValue, onGlobalFilterChange, handlerDateFilter, selectedPeriod, quickFilters, }) {
    const observerRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const loadingRef = (0, react_1.useRef)(loading);
    const paginationRef = (0, react_1.useRef)(pagination);
    (0, react_1.useEffect)(() => {
        loadingRef.current = loading;
        paginationRef.current = pagination;
    }, [loading, pagination]);
    const loadMore = (0, react_1.useCallback)(() => {
        if (loadingRef.current ||
            !paginationRef.current ||
            paginationRef.current.currentPage >= paginationRef.current.totalPages) {
            return;
        }
        if (fetchData) {
            fetchData(paginationRef.current.currentPage + 1, paginationRef.current.pageSize, true);
        }
    }, [fetchData]);
    (0, react_1.useEffect)(() => {
        if (!observerRef.current)
            return;
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMore();
            }
        }, {
            threshold: 0,
            rootMargin: '200px',
        });
        observer.observe(observerRef.current);
        return () => {
            observer.disconnect();
        };
    }, [loadMore]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "overflow-auto flex-1 relative", style: { paddingTop: '180px' }, children: [(0, jsx_runtime_1.jsx)(dataview_1.DataView, { value: loading && items?.length <= 0 ? Array(10).fill({}) : items, style: { marginBottom: '80px' }, emptyMessage: t('noRecords'), header: (0, jsx_runtime_1.jsx)("div", { style: { backgroundColor: 'rgb(231,238,248)' }, className: "shadow-md", children: (0, jsx_runtime_1.jsx)("div", { className: "w-full flex justify-between items-center", children: (0, jsx_runtime_1.jsx)("div", { className: "w-full", children: (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { globalFilterValue: globalFilterValue ?? '', onGlobalFilterChange: onGlobalFilterChange ?? (() => { }), handlerDateFilter: handlerDateFilter, selectedMonthYear: selectedPeriod, resetPageToFirst: () => { }, inputFilterActive: true, quickFilters: quickFilters }) }) }) }), itemTemplate: (item) => loading && items?.length <= 0 ? renderSkeleton?.() : renderItem(item) }), (0, jsx_runtime_1.jsx)("div", { ref: observerRef, style: { height: '1px' } }), loading && items?.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "loading-spinner flex justify-center py-2", children: (0, jsx_runtime_1.jsx)(progressspinner_1.ProgressSpinner, { style: { width: '25px', height: '25px' }, strokeWidth: "6", fill: "var(--surface-ground)", animationDuration: ".5s" }) }))] }));
}
